<template>
  <div>
    <div
      class="subheader py-2 py-lg-4 position-sticky custom-subheader"
      :class="subheaderClasses"
      id="kt_subheader"
      v-if="showSubHeader"
    >
      <div
        class="d-flex align-items-center justify-content-between"
        :class="{ 'container-fluid': widthFluid, container: !widthFluid }"
      >
        <div class="custom-subheader-menu d-flex align-items-center">
          <!-- Menu:start -->
          <div
            v-for="(item, index) in customHeaderParams.menuList"
            :key="index"
          >
            <span
              class="title mr-1"
              v-if="index + 1 < customHeaderParams.menuList.length"
            >
              <router-link
                :to="
                  item.route
                    ? $customFunctions.controlUrlAddFirstSplash(item.route)
                    : ''
                "
                >{{ $t(item.title) }}</router-link
              >
              >
            </span>
            <span class="subTitle" v-else>
              {{ item.notML == false ? item.title : $t(item.title) }}
            </span>
          </div>
          <!-- Menu:end -->

          <!-- Search:start -->
          <div v-if="showSearch" class="d-flex align-items-center">
            <hr class="filter-divider-custom" />
            <div class="form-search-input">
              <v-text-field
                class="my-0 font-size-sm"
                :placeholder="
                  $t(
                    customHeaderParams.searchPlaceholder
                      ? customHeaderParams.searchPlaceholder
                      : 'global.search'
                  )
                "
                prepend-icon="search"
                v-model="search"
                @keyup="searchKeyup"
                single-line
                dense
                flat
                solo
                hide-details
              ></v-text-field>
            </div>
            <hr
              class="filter-divider-custom"
              v-if="
                $route.path == '/compute/virtual-machines' &&
                lastThirdRecentSearches.length > 0
              "
            />
            <div
              class="recent-search-item"
              v-if="$route.path == '/compute/virtual-machines'"
              v-for="(recentSearchItem, searchIndex) in lastThirdRecentSearches"
              :key="'recent-search-item' + searchIndex"
            >
              <Label
                class="menu-nav-light"
                @click.native="setRecentSearch(recentSearchItem)"
                >{{ recentSearchItem }}</Label
              >
            </div>
          </div>
          <!-- Search:end -->
        </div>

        <div class="d-flex">
          <b-button
            v-if="showRefreshButton"
            variant="primary"
            class="w-mb-100 rounded-sm btn-sm"
            @click="refreshList"
          >
            <i class="far fa-sync" style="font-size: 14px"></i>
            {{ $t('global.refresh') }}
          </b-button>

          <b-button
            v-if="showDetailButton"
            variant="primary"
            class="w-mb-100 rounded-sm btn-sm ml-3"
            @click="openDetail"
          >
            <i
              v-if="showDetailIcon"
              :class="
                customHeaderParams.detailIcon
                  ? customHeaderParams.detailIcon
                  : 'far fa-plus-circle'
              "
            ></i>
            {{
              $t(
                customHeaderParams.detailPlaceholder
                  ? customHeaderParams.detailPlaceholder
                  : 'global.addNew'
              )
            }}
          </b-button>

          <a
            v-if="showExternalButton"
            :href="customHeaderParams.externalButtonUrl"
            target="_blank"
            class="btn btn-primary w-mb-100 rounded-sm btn-sm ml-3"
          >
            {{ $t(customHeaderParams.externalButtonText) }}
          </a>
        </div>

        <div
          v-if="customHeaderParams && customHeaderParams.statusLabel"
          class="d-flex"
        >
          <Label :class="customHeaderParams.statusLabel.toLowerCase()">
            {{ $t(`filters.${customHeaderParams.statusLabel.toLowerCase()}`) }}
          </Label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CLEAR_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

export default {
  name: 'KTCustomSubheader',
  data() {
    return {
      search: '',
      recentSearch: [],
    }
  },
  mounted() {
    let recentSearch = JSON.parse(window.localStorage.getItem('recentSearch'))
    if (recentSearch) {
      this.recentSearch = recentSearch
    }

    EventBus.$on(`clearSearch`, this.listener)
  },
  computed: {
    ...mapGetters(['layoutConfig', 'customHeaderParams']),
    widthFluid() {
      return this.layoutConfig('subheader.width') === 'fluid'
    },
    subheaderClasses() {
      const classes = []
      const style = this.layoutConfig('subheader.style')
      if (style) {
        classes.push(style)

        if (style === 'solid') {
          classes.push('bg-white')
        }

        if (this.layoutConfig('subheader.fixed')) {
          classes.push('border-top')
        }
      }
      return classes.join(' ')
    },
    showSubHeader() {
      return this.customHeaderParams && this.customHeaderParams != ''
    },
    showSearch() {
      return this.customHeaderParams.showSearch != undefined
        ? this.customHeaderParams.showSearch
        : true
    },
    showDetailButton() {
      return this.customHeaderParams.showDetailButton != undefined
        ? this.customHeaderParams.showDetailButton
        : true
    },
    showDetailIcon() {
      return this.customHeaderParams.showDetailIcon != undefined
        ? this.customHeaderParams.showDetailIcon
        : true
    },
    lastThirdRecentSearches() {
      return this.recentSearch.slice(-3).reverse()
    },
    showExternalButton() {
      return !!this.customHeaderParams.externalButtonUrl
    },
    showRefreshButton() {
      return this.customHeaderParams.showRefreshButton != undefined
        ? this.customHeaderParams.showRefreshButton
        : false
    },
  },

  beforeDestroy() {
    EventBus.$off(`clearSearch`, this.listener)
  },
  methods: {
    listener(payload) {
      this.search = ''
    },
    searchKeyup(e) {
      if (e.keyCode === 13) {
        this.searchList()

        if (
          !this.lastThirdRecentSearches.includes(this.search) &&
          this.search != ''
        ) {
          this.recentSearch.push(this.search)
          window.localStorage.setItem(
            'recentSearch',
            JSON.stringify(this.recentSearch)
          )
        }
      }
    },
    searchList() {
      EventBus.$emit('subHeaderSearch', this.search)
    },
    openDetail() {
      EventBus.$emit('subHeaderDetailOpen', true)
    },
    refreshList() {
      EventBus.$emit('subHeaderRefresh', true)
    },
    setRecentSearch(payload) {
      this.search = payload
      this.searchList()
    },
  },
  watch: {
    $route(to, from) {
      this.search = ''
      this.$store.dispatch(CLEAR_CUSTOMHEADERPARAMS)
    },
  },
}
</script>

<style lang="scss">
.custom-subheader {
  margin-top: -25px !important;
  margin-bottom: 25px !important;

  .custom-subheader-menu {
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #b5b5c3;
    }
    .subTitle {
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
    }
    a {
      color: #b5b5c3 !important;
    }

    .recent-search-item {
      cursor: pointer;
      margin-right: 10px;

      &:last-child {
        margin-right: 0px;
      }
    }
  }
}
</style>
